import { Button, Tabs } from '@eleo-rh/core-ui'
import Page403 from 'components/Page403'
import SectionTitle from 'components/UI/SectionTitle'
import Accreditation from 'containers/Catalog/Accreditation/Accreditation'
import Matrix from 'containers/Catalog/Matrix'
import Training from 'containers/Catalog/Training/Training'
import { useI18n } from 'context/I18nProvider'
import { useProfile } from 'context/ProfileProvider'
import { useModules } from 'hooks/modules'
import { useTitle } from 'hooks/title'
import { useNavigate, useParams } from 'react-router-dom'

type Tab = {
  key: string
  label: string
  children: React.ReactNode
  permission?: string
}

function CatalogNav() {
  const { lang, tab } = useParams()
  const navigate = useNavigate()
  const { hasPermission } = useProfile()
  const { i18n } = useI18n()
  const { hasSafety, hasTraining } = useModules()

  useTitle(i18n('menu.catalog'))

  const TABS: Tab[] = [
    ...(hasTraining
      ? [
          {
            key: 'training',
            label: i18n('label.trainings').toUpperCase(),
            children: <Training />,
            permission: 'CATALOG_CAN_SEE_CATALOG',
          },
        ]
      : []),
    ...(hasSafety
      ? [
          {
            key: 'accreditation',
            label: i18n('menu.admin_accreditations').toUpperCase(),
            children: <Accreditation />,
            permission: 'ACCREDITATION_CAN_SEE_CATALOG',
          },
        ]
      : []),
    {
      key: 'matrix',
      children: <Matrix />,
      label: i18n('page_title.jobs_references').toUpperCase(),
      permission: 'MATRIX_CAN_SEE_MATRIX',
    },
  ]

  const canAccessPage = TABS.some(t => hasPermission(t.permission))
  if (!canAccessPage) {
    return <Page403 />
  }

  const tabs = TABS.filter(t => hasPermission(t.permission))

  const singleTab = tabs.length === 1 ? tabs[0] : null

  const handleChange = (key: string) => navigate(`/${lang}/catalog/${key}`)

  const tabBarExtraContent = tab === 'training' && hasPermission('CATALOG_CREATE_OUT_OF_CATALOG') && (
    <div className="flex items-center">
      <span className="text-sm mr-4">{i18n('question.you_dont_find_your_training')}</span>
      <Button onClick={() => navigate('free-wish')}>{i18n('action.free_wish')}</Button>
    </div>
  )

  const catalogTitle = () => {
    if (singleTab) {
      return singleTab.label
    }
    return i18n('menu.catalog').toUpperCase()
  }

  return (
    <div className="flex flex-col gap-4">
      <SectionTitle level={1} size="2xl" extra={singleTab && tabBarExtraContent}>
        {catalogTitle()}
      </SectionTitle>
      {singleTab ? (
        singleTab.children
      ) : (
        <Tabs
          activeKey={tab}
          items={tabs}
          onChange={handleChange}
          destroyOnHidden
          tabBarExtraContent={tabBarExtraContent}
        />
      )}
    </div>
  )
}

export default CatalogNav
